/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */

// Slurs and swearing in a transcript, marked for the reader, never censored.
// ponytail: a fixed English list; add words here as reviewers report misses.

// word starts: any ending counts ("fuck" marks "fucking", "motherfucker")
const STEMS = [
  'fuck',
  'motherfuck',
  'shit',
  'bullshit',
  'bitch',
  'bastard',
  'cunt',
  'dickhead',
  'asshole',
  'arsehole',
  'piss',
  'wank',
  'twat',
  'slut',
  'whore',
  'skank',
  'goddamn',
  'damn',
  'nigger',
  'nigga',
  'wetback',
  'kike',
  'raghead',
  'towelhead',
  'gyppo',
  'faggot',
  'tranny',
  'shemale',
  'retard',
  'spastic',
  'darkie',
  'beaner',
];
// whole words (or their plural) only: as a word start they'd mark innocent words
// ("dickens", "cocoon", "pakistan", "spice", "chinking")
const WORDS = [
  'dick',
  'fag',
  'dyke',
  'coon',
  'hoe',
  'spic',
  'paki',
  'chink',
  'gook',
  'negro',
];

const SLUR = new RegExp(
  `\\b(?:(?:${STEMS.join('|')})[a-z]*|(?:${WORDS.join('|')})(?:s|es)?\\b)`,
  'gi',
);

/** The text in parts, each {text, slur}; joined back they are the text unchanged. */
export function markSlurs(text) {
  const parts = [];
  let at = 0;
  for (const m of String(text ?? '').matchAll(SLUR)) {
    if (m.index > at) parts.push({text: text.slice(at, m.index), slur: false});
    parts.push({text: m[0], slur: true});
    at = m.index + m[0].length;
  }
  if (at < String(text ?? '').length)
    parts.push({text: text.slice(at), slur: false});
  return parts;
}
